"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    gatewayRewriteConfig: ()=>gatewayRewriteConfig,
    productBackupLinkTemplate: ()=>productBackupLinkTemplate,
    rowApiConfig: ()=>rowApiConfig,
    rowGatewayOriginConfig: ()=>rowGatewayOriginConfig,
    rowHostnameConfig: ()=>rowHostnameConfig,
    rowOtherHostnameConfig: ()=>rowOtherHostnameConfig
});
const rowApiConfig = {
    cnBytedJwt: 'https://cloud.byted.org/auth/api/v1',
    cnTTPRoWJwt: 'https://cloud-cn.tiktok-row.net/auth/api/v1',
    localTestJwt: 'https://cloud-boe-sandbox.byted.org/auth/api/v1',
    i18nByteIntlJwt: 'https://cloud-i18n.byteintl.net/auth/api/v1',
    i18nByted: 'https://cloud-i18n-og.byted.org/auth/api/v1',
    ttpRowOrg: 'https://cloud.tiktok-row.org/auth/api/v1',
    sinfBytedance: 'https://cloud-sinf-jwt.bytedance.net/auth/api/v1',
    cnByteintl: 'https://cloud-cn.byteintl.net/auth/api/v1'
};
const rowHostnameConfig = {
    sandbox: 'cloud-sandbox.bytedance.net',
    boe: 'cloud-boe.bytedance.net',
    online: 'cloud.bytedance.net',
    hl: 'cloud-hl.bytedance.net',
    lq: 'cloud-lq.bytedance.net',
    pd: 'cloud-pd.bytedance.net',
    us: 'cloud-us.bytedance.net',
    i18n: 'cloud-i18n.bytedance.net',
    'i18n-sg': 'cloud-i18n-sg.bytedance.net',
    'boe-i18n': 'cloud-boe-i18n.bytedance.net',
    'ttp-us-limited': 'cloud-ttp-us.bytedance.net',
    tx: 'cloud-tx.bytedance.net',
    xfl: 'cloud-xfl.bytedance.net',
    'sinf-xfl': 'cloud.xfl.net',
    'sinf-xfl-boe': 'cloud-boe.xfl.net',
    'sinf-boe': 'cloud-boe.sinf.net',
    sinf: 'cloud.sinf.net',
    sinfi18n: 'cloud-i18n.sinf.net',
    sinfonlinea: 'cloud-sinfonlinea.sinf.net',
    volcgroup: 'cloud.volcgroup.com',
    'volcgroup-boe': 'vgcloud-boe.bytedance.net',
    'i18n-bd': 'cloud.byteintl.net',
    'i18n-bd-de': 'cloud-de.byteintl.net'
};
const rowOtherHostnameConfig = {
    eden: 'dev.eden.net',
    arco: 'arco.design',
    arcoByte: 'arco.bytedance.net',
    developer: 'cloud-developer.bytedance.net',
    developerBoe: 'cloud-developer-boe.bytedance.net',
    docsDev: 'cloud-docs-dev.bytedance.net',
    huailai: 'cloud-huailai.bytedance.net',
    cloudBoe: 'cloud.boe.bytedance.net',
    backupOnline: 'cloud-backup.bytedance.net',
    backupUs: 'cloud-us-backup.bytedance.net',
    backupI18n: 'cloud-i18n-backup.bytedance.net',
    backupTtpUsLimited: 'cloud-ttp-us-backup.bytedance.net',
    backupBoe: 'cloud-boe-backup.bytedance.net',
    backupSinfXfl: 'cloud-xfl-backup.bytedance.net',
    backupSinf: 'cloud-sinf-backup.bytedance.net',
    backupSinfBoe: 'cloud-sinf-boe-backup.bytedance.net',
    test: 'cloud-test.bytedance.net'
};
const rowGatewayOriginConfig = {
    boei18n: 'https://cloud-boei18n.bytedance.net'
};
const gatewayRewriteConfig = {
    scm: 'https://scm.byted.org',
    scmHL: 'https://scm-hl.byted.org',
    scmRow: 'https://scm-sce.tiktok-row.org'
};
const productBackupLinkTemplate = 'https://w7ajvrq9.fn.bytedance.net/get_cache/{file_key}.json';
exports.gatewayRewriteConfig = __webpack_exports__.gatewayRewriteConfig;
exports.productBackupLinkTemplate = __webpack_exports__.productBackupLinkTemplate;
exports.rowApiConfig = __webpack_exports__.rowApiConfig;
exports.rowGatewayOriginConfig = __webpack_exports__.rowGatewayOriginConfig;
exports.rowHostnameConfig = __webpack_exports__.rowHostnameConfig;
exports.rowOtherHostnameConfig = __webpack_exports__.rowOtherHostnameConfig;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "gatewayRewriteConfig",
    "productBackupLinkTemplate",
    "rowApiConfig",
    "rowGatewayOriginConfig",
    "rowHostnameConfig",
    "rowOtherHostnameConfig"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
